import { LogoLoader } from "./LogoLoader";
import { cn } from "../utils/cn";

export interface LoadingSpinnerProps {
  className?: string;
  size?: "sm" | "md" | "lg" | "xl" | number;
}

/**
 * LoadingSpinner - Uses the shared LogoLoader
 */
export const LoadingSpinner = ({
  className,
  size = "sm",
}: LoadingSpinnerProps) => {
  return <LogoLoader size={size} className={className} />;
};

export interface LoadingStateProps {
  className?: string;
  message?: string;
  size?: "sm" | "md" | "lg" | "xl" | number;
}

/**
 * LoadingState - Consistent loading UI with LogoLoader
 */
export const LoadingState = ({
  className,
  message = "데이터를 불러오는 중...",
  size = "md",
}: LoadingStateProps) => {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center min-h-[200px] gap-4",
        className,
      )}
    >
      <LogoLoader size={size} text={message} showText />
    </div>
  );
};

export interface LoadingScreenProps {
  className?: string;
  /** 화면에는 쓰지 않고 화면 읽기 도구에만 읽어 준다. */
  message?: string;
}

/**
 * LoadingScreen - 화면 전체 로딩(첫 진입·로그인 확인·화면 받기).
 * 이어서 뜨는 전체 로딩들이 같은 자리·같은 크기여야 한 번의 로딩으로 보인다.
 * 글자를 넣지 않는 이유도 같다 — 단계마다 문구가 바뀌면 로고가 위아래로 밀린다.
 */
export const LoadingScreen = ({
  className,
  message = "화면을 불러오는 중",
}: LoadingScreenProps) => {
  return (
    <div
      className={cn(
        "flex min-h-svh w-full items-center justify-center bg-background",
        className,
      )}
      role="status"
      aria-label={message}
    >
      <LogoLoader size="md" aria-hidden="true" />
    </div>
  );
};
